export default {
  // 侧边导航栏
  navigation: {
    home: '首页',
    gameCenter: '游戏中心',
    rechargeCenter: '充值中心',
    imChat: 'IM聊天',
    consult: '星遇咨讯',
  },

  // 首页
  home: {
    platformFeatures: '平台特色',
    quickActionsName: '快速操作',
    footerText: '让直播更简单，让互动更有趣',
    features: {
      gameCenter: {
        title: '游戏中心',
        description: '丰富的游戏资源，支持多平台直播',
      },
      imChat: {
        title: '即时通讯',
        description: '实时聊天互动，提升观众体验',
      },
      dataAnalysis: {
        title: '数据分析',
        description: '详细的数据统计，助力直播优化',
      },
      efficientStable: {
        title: '高效稳定',
        description: '流畅的直播体验，稳定的服务保障',
      },
    },
    stats: {
      activeUsers: '活跃用户',
      gameResources: '游戏资源',
      serviceAvailability: '服务可用性',
      technicalSupport: '技术支持',
    },
    quickActions: {
      gameCenter: '游戏中心',
      imChat: 'IM聊天',
      consult: '星遇咨询',
    },
  },

  // 游戏中心
  gameCenter: {
    language: '简体中文',
    balance: '余额',
    hotGames: '热播游戏',
    download: '下载',
    update: '更新',
    startTikTok: '正常开播',
    startBigo: '开播',
    document: '文档',
    currentGame: '当前开播游戏：',
    currentStatus: '当前开播状态：',
    recharge: '充值',
    restart: '重启工具及游戏',
    closeLive: '关播',
    downloadProgress: '下载进度：',
    decompProgress: '解压进度：',
    waitDecomp: '等待解压',
    fixBug: '修复bug（Fix bug）',
    clickUpdate: '点击更新(Click update)',
    downloading: '下载中，请耐心等候~（Please wait patiently while downloading ~）',
    // toolstatue:'等待工具开启中……',
    // toolstatue2:'工具启动成功，等待游戏连接中……',
    // toolstatue3:'游戏连接成功，祝您开播愉快~~~',
    pay: '支付中...',
    xzf: '需要支付',
    zs: '钻石',
    dest: '弹幕游戏 防封插件',
    getff: '解锁防封权限',
    ffbtun: '防机审开播',
    qrkb: '确认开播',
    tkl: '您准备好启动防机审开播了吗？',
    qd: '确认',
    qx: '取消',
  },

  // IM聊天
  imChat: {
    search: '搜索',
    searchNoResult: '暂未搜索到该用户',
    tryOtherKeywords: '请尝试其他搜索关键词',
    noConversations: '暂无聊天记录',
    startChatting: '搜索用户开始聊天吧',
    loadingConversations: '加载会话列表中...',
    connecting: '正在连接聊天服务器...',
    connectionFailed: '⚠️连接失败，聊天功能暂不可用',
    checkNetwork: '请检查网络连接或联系客服',
    selectUser: '请选择一个用户开始聊天',
    sending: '发送中...',
    sendMessage: '发送',
    enterMessage: '请输入消息...',
    noMessages: '暂无消息',
    welcomeChat: '欢迎使用聊天功能',
    selectConversationHint: '请从左侧选择一个会话开始聊天',
    inputDisabledDisconnected: '连接已断开，聊天暂不可用，其他功能正常，恢复聊天功能请重新登录再试',
    inputDisabledOfficialNotification: '官方通知为单向通知，您只能接收消息',
    RecentSessions: '最近会话',
    RecommendedChat: '全球好友',
    Online: '在线',
    Offline: '离线',
  },

  //资讯
  StalConsult: {
    search2: '搜索',
    all: '全部',
    Payment: '支付',
    ViewFullContent: '查看全部内容',
    UnlockFullContent: '解锁全部内容',
    NeedToPay: '需要支付',
    diamond: '钻石',
    CurrentBalance: '当前余额',
    Cancel: '取消',
    PayNow: '立即支付',
    InsufficientBalance: '余额不足',
    loading: '加载中...',
    NoMoreContent: '没有更多内容了',
    return: '返回',
    fd: '放大查看',
  },

  // 通用提示
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    loading: '加载中...',
    success: '成功',
    failed: '失败',
    error: '错误',
    warning: '警告',
    info: '信息',
  },
}
